import { api, dmStore } from 'dmui_components'
import { ref, inject, reactive, watchEffect, onMounted } from 'vue'

let rolesCache

/**
 * Get Roles and cache it
 * @param {*} roles
 * @returns
 */
async function getRoles() {
	try {
		if (!rolesCache) {
			rolesCache = await api(`/roles`)
		}
		return rolesCache
	} catch (e) {
		console.error('Error while getting roles', e)
		throw e
	}
}

/**
 * Composable to return hasPermission helper function and status of permission being
 * loaded
 * @returns {
 * 	hasPermission : Function
 * 	permissionsLoaded : boolean ref
 * }
 */
export default function permissionChecker() {
	const permissionsLoaded = ref(false)
	const user = inject('user', undefined)
	const hasUserRolesFeature = dmStore.hasFeature('user_roles')
	const userPermissions = reactive({})
	const roles = ref([])
	const isUserDataLoaded = () => {
		if (user.value) {
			return true
		} else {
			return new Promise((resolve) => {
				const unwatch = watchEffect(() => {
					if (user.value) {
						unwatch()
						resolve()
					}
				})
			})
		}
	}

	onMounted(async () => {
		if (hasUserRolesFeature) {
			await isUserDataLoaded()
			roles.value = await getRoles()
			const userRoles =
				roles.value?.filter(({ _id }) => {
					return (user.value?.submaran_roles || []).indexOf(_id) !== -1
				}) || []
			userRoles.forEach((role) => {
				const permissions = role?.permissions || {}
				Object.keys(permissions).forEach((key) => {
					userPermissions[key] = userPermissions[key] || {}
					permissions[key].split('').forEach((permission) => {
						userPermissions[key][permission] = true
					})
				})
			})
		}
		permissionsLoaded.value = true
	})
	return {
		// To check the status of whether permissions are loaded from api or not
		permissionsLoaded,
		/**
		 * To check whether the current user has the specific permission to specific feature
		 *
		 * @param {*} feature
		 * @param {*} permissionsString - For multiple pass without spaces e.g rwd
		 * @returns
		 */
		hasPermission: (feature, permissionsString = 'r') => {
			let result
			if (hasUserRolesFeature) {
				result = true
				permissionsString.split('').forEach((perm) => {
					result = result && userPermissions[feature]?.[perm]
				})
			} else {
				// If roles feature is disabled then true by default
				result = true
			}
			return result
		}
	}
}
